//TODO: Generate this file npm generate all plugins facade
import './GA/index.jsx';


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/all.jsx